export default {
  adminDashboard: {
    booking: {
      download: 'Download booking analytics',
      downloadAppointmentBookingLogs: 'Download appointment booking logs',
      downloadAppointmentBookingLogsError:
        'Unable to download appointment booking logs. Please try again.',
      downloadBookingLogsError:
        'Unable to download booking analytics. Please try again.',
      downloadingAppointmentBookingLogs: 'Downloading...',
      title: 'Booking Dashboard',
    },
    chats: {
      chart: {
        answeredWithin4Hours: {
          caption:
            'per month out of total {{total}} conversations the {{year}} year',
          line: {
            answeredWithin4Hours: 'Answered within 4 hours',
          },
          title: 'Chats answered within first 4 hours',
        },
        closedOpened: {
          caption: 'per month out of total {{total}} conversations',
          key: {
            closed: 'Closed',
            open: 'Open',
          },
          title: 'Closed vs opened',
        },
        conversations: {
          caption: 'this year {{year}}',
          title: 'Conversations',
        },
        reasons: {
          caption: 'per month out of total {{total}} conversations',
          title: 'Reasons for entry',
        },
        responseTime: {
          caption:
            'per month out of total {{total}} conversations the {{year}} year',
          line: {
            firstReplyTime: 'First reply time',
            openedTime: 'Opened time',
          },
          title: 'Response time',
          yAxis: 'hours',
        },
      },
      monthly: 'Monthly',
      title: 'Chats',
    },
    tabs: {
      booking: 'Booking Dashboard',
      chats: 'Chats Dashboard',
      users: 'Users Dashboard',
    },
    users: {
      actions: {
        download: 'Download users',
      },
      chart: {
        activePatients: {
          caption: '{{activePatients}} out of {{patients}} this month',
          title: 'Active patients',
        },
        newUsersByMonth: {
          caption: 'by month in {{year}}',
          title: 'New patients ',
        },
        pie: {
          clinicians: 'Clinicians',
          unverified: 'Unverified',
          verifiedPatients: 'Verified patients',
        },
        totalUsers: {
          caption: 'out of total {{users}} users',
          title: 'Users',
        },
      },
      title: 'Users',
    },
  },
  auth: {
    logout: 'Logout',
    noPermissions: `You don't have permissions to access this page.`,
  },
  brochures: {
    actions: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    addTreatment: 'Add treatment',
    allCategories: 'All',
    confirm: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      header: 'Confirm treatment',
      text: 'Are you sure you want to confirm the treatment?',
    },
    failedToEdit: 'Failed to edit folder',
    filterPlaceholder: 'Filter by category',
    noBrochures:
      'This patient has no folders yet. Add a treatment to get started.',
    preview: {
      email: 'Email',
      error: {
        description: 'Please try again later',
        title: 'Something went wrong',
      },
      language:
        'In which language would you like to show and send the leaflet?',
      languages: {
        'en-GB': 'English',
        'nl-NL': 'Dutch',
      },
      print: 'Print',
      sendConfirm: {
        cancel: 'Cancel',
        confirm: 'Send',
        error: 'Something went wrong. Please try again later.',
        header: 'Send leaflet to patient',
        success: 'The leaflet has been sent successfully.',
        text: "Are you sure you want to send the leaflet to the patient's email address {{email}}?",
      },
    },
    removeBrochures: 'Remove treatment',
    searchPlaceholder: 'Search all treatments',
    sidebarTitle: 'Treatments',
    status: {
      emailed: 'Emailed on {{date}}',
      printed: 'Printed on {{date}}',
    },
    title: 'Folders',
  },
  chat: {
    actions: {
      approveAndSend: 'Approve and send',
      cancel: 'Cancel',
      close: 'Close chat',
      edit: 'Edit',
      queueLabel: 'Queue',
      reasonLabel: 'Reason',
      returnToQueue: 'Return to queue',
      revert: 'Discard changes',
      save: 'Save',
      start: 'Start chatting',
    },
    assign: {
      button: 'Assign to',
      confirmModal: {
        button: 'Assign chat',
        cancel: 'Cancel',
        confirm: 'Assign chat',
        header: 'Assign chat?',
        text: 'If you assign the chat, the internal chat will be closed. You can view past internal chats up to one week old in the patient information panel.',
      },
      modal: {
        button: 'Assign chat',
        header: 'Assign to',
        inputPlaceholder: 'Search all users',
      },
    },
    close: {
      cancel: 'Cancel',
      confirm: 'Close Chat',
      confirmAndSaveReport: 'Close chat & save report',
      conversation: {
        header: 'Close chat?',
        text: 'Closing this chat will also close internal chats. This action cannot be undone. You can view past chats up to one week old in the patient information panel.',
      },
      includeImages: 'Include images sent by the patient',
      internal: {
        header: 'Close internal chat?',
        text: 'Closing the internal chat will not close the chat with the patient. You can view past internal chats up to one week old in the patient information panel.',
      },
      patientNotes: 'Patient record notes',
      saveReport: 'Save report for this chat',
      triageNote: 'Triage answers will be included automatically',
    },
    events: {
      conversationAssignedTo: 'Chat has been assigned to {{user}}',
      conversationClosedBy: 'Chat has been closed by {{user}}',
      conversationMovedToQueue: 'Chat has been moved to {{queue}}',
      conversationReasonForEntryChanged:
        'Reason for entry changed from {{old}} to {{new}} by {{user}}',
      conversationUnassignedBy:
        'Chat has been returned to the queue by {{user}}',
      conversationUnassignedBySystem:
        'Chat has been returned to the queue automatically by the system',
    },
    hiddenImage: 'Images are not available in past chats',
    inbox: 'Inbox',
    inputPlaceholder: 'Write your message here',
    noActiveConversations: 'Select a patient to start chatting',
    notifications: {
      conversationCreated: 'New conversation from {{user}}',
      internalConversationCreated: 'New internal chat from {{user}}',
      messageAdded: 'New message from {{user}}',
    },
    ongoingConversations: 'Ongoing chats',
    queue: 'Queue',
    reasons: {
      Urgent: 'Urgent',
    },
    returnToQueue: {
      cancel: 'Cancel',
      confirm: 'Return to queue',
      header: 'Return chat to queue?',
      text: 'If you return the chat to the queue, the internal chat will be closed and the other party won’t be able to see the internal chat anymore. You can view past internal chats up to one week old in the patient information panel.',
    },
    suggestion: {
      feedback: {
        defects: 'Defects',
        editedMessage: 'Edited message:',
        header: 'Review edited response',
        originalMessage: 'Original message:',
        send: 'Send message',
      },
      messageLabel: 'Please review this generated response',
    },
    triage: {
      accordionTitle: 'Patient triage questions',
    },
    userTyping: '{{name}} is writing',
  },
  common: {
    searchInputClear: 'Clear',
  },
  connectionBanner: {
    dismiss: 'Dismiss',
    message: 'Chat connection unavailable.',
    retry: 'Retry',
  },
  consultations: {
    action: {
      closeConsultation: 'Close consultation',
      readyForReview: 'Ready for practitioner',
    },
    chat: {
      finished: 'Patient can no longer respond to this e-consultation',
    },
    closeConsultation: {
      action: {
        cancel: 'Cancel',
        close: 'Close e-consult & save transcript',
      },
      description:
        'After closing this e-consult a transcript of the e-consult and images sent will be saved as a pdf in EMMA. You can add an optional additional note below.',
      label: 'Add note (optional)',
      title: 'Close e-consult?',
    },
    errorClosing:
      'We couldn’t finalize the consultation due to an error. Please try again or refresh the page.',
    noConsultationsSelected: 'Select a consultation to start',
    queue: {
      finished: 'Finished',
      finishedTooltip: "Consultation has finished but patient hasn't read it",
      patient: 'Patient',
      readyForReview: 'Ready for practitioner',
      readyForReviewTooltip: 'Consultation is ready for practitioner review',
      title: 'E-consultations',
    },
    submitMessage: {
      action: {
        cancel: 'Cancel',
        send: 'Send reply',
        sendAndClose: 'Send and close',
      },
      description:
        'Allow for patient reply if you have asked the patient a follow up question that requires additional clarification.',
      options: {
        allowReply: 'Allow for patient reply (e-consultation will remain open)',
        doNotAllowReply:
          'Do not let patient reply (e-consultation will be closed for patient)',
      },
      title: 'Allow for patient reply?',
    },
  },
  dcAssistant: {
    chatAssistant: 'Chat Assistant',
    inputPlaceholder: 'Ask the AI assistant a question about this patient',
    patientKnowledgeBase: 'Patient Knowledge Base',
  },
  econsultations: {
    undo_ready: 'Undo ready',
    undo_ready_modal_confirm: 'Undo',
    undo_ready_modal_description:
      'This will return the e-consultation to active status.',
    undo_ready_modal_title: 'Undo ready for practitioner?',
  },
  generic: {
    noEmail: 'NO EMAIL AVAILABLE',
  },
  handTherapy: {
    actions: {
      add: 'add',
      cancel: 'cancel',
      confirm: 'assign program',
      remove: 'remove',
    },
    changeProgram: 'Change selected program',
    exercises: {
      button: 'Add exercise',
      frequency: 'Number of times',
      frequencyOptions: {
        day: 'day',
        hour: 'hour',
      },
      instructions: 'Instructions',
      locations: {
        clinic: 'In-clinic',
        home: 'At home',
      },
      reps: 'Reps / Duration',
      rest: 'Rest',
      sets: 'Sets',
      title: 'Exercises',
      videoPreview: 'Video preview',
    },
    notFound: {
      backTo: 'Search patients',
      title:
        "Sorry, we can't find the program {{programId}} anymore. Search for a patient to continue.",
    },
    sidebar: {
      allAreasLabel: 'All areas of concern',
      allLocations: 'All locations',
      area: {
        dexterity: 'Exercise room: dexterity',
        elbow: 'Elbow',
        finger: 'Finger',
        general: 'ADL exercises',
        mobility: 'Exercise room: mobility',
        nerve: 'Nerve',
        shoulder: 'Shoulder',
        strength: 'Exercise room: strength',
        thumb: 'Thumb',
        wrist: 'Wrist',
      },
      areaOfConcernPlaceholder: 'Area of concern',
      locations: {
        clinic: 'In-clinic',
        home: 'At home',
      },
      locationsPlaceholder: 'Locations',
      searchExercisesPlaceholder: 'Search all exercises',
      title: {
        exercises: 'Exercises',
        splints: 'Splint',
      },
    },
    splints: {
      button: 'Add splint',
      frequencyOptions: {
        day: 'day',
        'day-night': 'day and night',
        night: 'night',
      },
      instructions: 'Instructions',
      title: 'Splint',
      wearDuring: 'Wear During',
    },
  },
  internalChat: {
    action: 'Start internal chat',
    placeholder: 'Write a message',
    searchbarPlaceholder: 'Search users',
    title: 'Internal chat:',
  },
  login: {
    confirm: 'Log in',
    description: 'Log in with eCumulus to continue',
  },
  navbar: {
    activations: 'Activations',
    adminPanel: 'admin',
    chat: 'Chat',
    chatAssistant: 'Chat Assistant',
    dashboard: 'Dashboard',
    eConsultations: 'E-Consultations',
    logout: 'Logout',
    patients: 'Patients',
    userManagement: 'User Management',
  },
  patientScreen: {
    navigation: {
      brochures: {
        description: 'Create a treatment plan for patients',
        title: 'Folders',
      },
      eConsultations: {
        description:
          'Consult your patients virtually. View and respond to your patients’ concerns.',
        title: 'E-consultations',
      },
      exercises: {
        description:
          'Create an exercise plan for your patients. Assign splint and exercise instructions',
        title: 'Exercises',
      },
      knowledgeBase: {
        description:
          'Ask questions about patient care paths, appointments, and treatment plans',
        title: 'Patient Knowledge Base',
      },
      openButton: 'Open',
      pdfLookup: {
        description:
          'Search for diagnosis information. Share or print care path information.',
        title: 'PDF Lookup',
      },
    },
    notFound: {
      backTo: 'Search patients',
      title: 'Patient not found',
    },
  },
  patientSearch: {
    actions: {
      clear: 'Clear',
    },
    instructions: 'Press Enter to search patients',
    noResults: 'No patients found',
    searchbarPlaceholder: 'Search by patient name or ID',
    shortQueryWarning: 'Please enter at least 3 characters to search',
    title: 'Hello, {{name}}',
  },
  patientSidebar: {
    carePath: {
      appointmentActions: {
        appointmentList: 'Appointment list',
        cancelAction: 'Cancel appointment',
        cancelSuccess: 'Appointment cancelled successfully.',
        cancelTitle: 'Cancel appointment',
        changeAction: 'Change appointment time',
        changeSuccess: 'Appointment time updated successfully.',
        changeTitle: 'Change appointment time',
        confirmCancel: 'Cancel appointment',
        confirmCancelText:
          'You are about to cancel this appointment for the patient. Please confirm that the patient has approved this action.',
        confirmCancelTitle: 'Confirm cancellation',
        confirmChange: 'Change appointment time',
        confirmChangeText:
          'You are about to change this appointment for the patient. Please confirm that the patient has approved the new appointment time.',
        confirmChangeTitle: 'Confirm appointment change',
        detailsTitle: 'Appointment details',
        mutationStatusUnknown:
          'The request was received, but the result could not be confirmed. Do not submit it again; refresh the appointment list first.',
        newSlot: 'New appointment time',
        noSlots: 'No alternative timeslots are available right now.',
        otherReasonPlaceholder: 'Add a short explanation',
        reasonTitle: 'Reason',
        reportingTime: 'Reporting time: {{time}}',
        reviewCancel: 'Review cancellation',
        reviewChange: 'Review change',
        selectSlot: 'Select a new timeslot',
        slotsUnavailable:
          'Alternative timeslots could not be loaded. Please try again.',
        submitting: 'Saving...',
        warningTitle: 'Warning',
      },
      closedCarePaths: 'Closed treatments',
      currentCarePaths: 'Current treatments',
      joinCall: 'Join Call',
      loadingAppointments: 'Loading...',
      nMore: '{{num}} more',
      noActiveCarePaths: 'No active treatments',
      noClosedCarePaths: 'no closed treatments',
      noContent: 'There are no appointments to display.',
      noMoreAppointments: 'No more appointments',
      numActiveCarePathsPlural: '{{num}} active treatments',
      numActiveCarePathsSingular: '1 active treatment',
      numClosedCarePathsPlural: '{{num}} closed treatments',
      numClosedCarePathsSingular: '1 closed treatment',
      past: 'Past',
      planned: 'Planned',
      today: 'Today',
    },
    chats: {
      backToList: 'Back to chat list',
      internal: {
        title: 'Internal chat',
      },
      noContent: 'There are no chats to display.',
      noEvents: 'There are no events to display.',
      ongoing: 'Ongoing',
      past: 'Past',
    },
    expandProfile: 'Expand patient profile',
    openPatientHub: 'Open patient hub',
    pdfs: {
      created: 'Treatment: {{- date}}',
      error: {
        description: 'Please try again later',
        title: 'Something went wrong',
      },
      languages: {
        'en-GB': 'English',
        'nl-NL': 'Dutch',
      },
      noCarePlanSelected: {
        description: 'Please select a care plan from the list',
        title: 'There are no items to display right now',
      },
      noCarePlans: 'No care plans found',
      onGoingCarePlans: 'Ongoing care plans',
      pastCarePlans: 'Past care plans',
      sendPDF: {
        cancel: 'Cancel',
        confirm: 'Send',
        error: 'Something went wrong. Please try again later.',
        header: 'Send client instruction to patient',
        language: 'In which language would you like to send the PDF?',
        success: 'The PDF has been sent successfully.',
        text: "Are you sure you want to send the PDF to the patient's email address {{email}}?",
      },
    },
    questionnaires: {
      completed: 'Completed',
      expired: 'Expired',
      noContent: 'There are no questionnaires to display.',
      patient: 'Patient Questionnaires',
      therapist: 'Therapist Questionnaires',
      todo: 'Todo',
    },
    tabs: {
      carePath: 'Appointments',
      chats: 'Chat',
      questionnaires: 'Questionnaires',
    },
  },
  patientSidebarScreen: {
    backToCandidates: 'Back to found patients',
    error: 'Error fetching the patient information',
    multipleMatches: 'Multiple patients were found. Select the right patient.',
    notFound: 'No patient found for this conversation.',
    selectPatient: 'Select',
  },
  preCall: {
    description:
      'Scan the QR code with a mobile device to join the video call. Alternatively, type in the link below in the browser of your mobile device and enter the code.',
  },
  programSelection: {
    actions: {
      cancel: 'Cancel',
      confirm: 'Select program',
    },
    exercise: 'Exercise',
    noPrograms: 'No programs found',
    searchPlaceholder: 'Search programs',
    splint: 'Splint',
    titles: {
      change: 'Change program',
      select: 'Select program',
    },
  },
  routeError: {
    backToPatients: 'Back to patients',
    description: 'Please try again or go back to the patient list.',
    title: 'Something went wrong',
  },
  unknown: 'unknown',
  userManagement: {
    actions: {
      cancel: 'Cancel',
      delete: 'Delete',
      save: 'Save',
    },
    activations: {
      actions: {
        download: 'Download activations',
        findMatches: 'Find Matches',
      },
      columns: {
        actions: 'Actions',
        activated: 'Activated',
        activatedAt: 'Activated At',
        bsn: '...BSN',
        dateOfBirth: 'Date of birth',
        dateOfRequest: 'Date of request',
        email: 'Email',
        firebaseId: 'Firebase ID',
        name: 'Name',
        phoneNumber: 'Phone',
        status: 'Status',
      },
      delete: {
        action: 'Delete',
        cancel: 'Cancel',
        clearSelection: 'Clear selection',
        close: 'Close',
        codes: {
          activated: 'Already activated',
          'db-error': 'Data could not be deleted',
          'firebase-error': 'Account could not be deleted',
          'linked-patient': 'Linked to a patient record',
          'not-found': 'Not found (may already be deleted)',
          'own-account': 'Your own account',
          'privileged-account': 'Staff account',
        },
        confirm: 'Delete permanently',
        error: 'Deleting failed. Please try again.',
        message:
          '{{count}} selected account(s) and the related request data will be permanently deleted. The person will be signed out and has to register again to use the app.',
        pending: 'Deleting...',
        reasonLabel: 'Reason',
        reasonPlaceholder: 'Choose a reason',
        reasons: {
          duplicate: 'Duplicate request',
          no_match: 'No match found',
          other: 'Other',
          subject_request: 'At the request of the person',
          test_account: 'Test account',
        },
        selectPage: 'Select all on this page',
        selectRow: 'Select row',
        selected: '{{count}} selected',
        summary: '{{deleted}} deleted, {{skipped}} skipped, {{failed}} failed',
        title: 'Permanently delete accounts',
        warning: 'This action cannot be undone.',
      },
      display: 'Display: {{amount}} of {{total}}',
      displayFocused: 'Focused view: {{email}}',
      errorLoadingMatches: 'Error loading matches',
      filtering: 'Filtering...',
      loading: 'Loading...',
      loadingMatches: 'Loading matches',
      manualEntry: {
        clearSelection: 'Clear selection',
        errors: {
          invalidFormat:
            'Invalid format. Use <patient-id>@<org-id> (e.g., 1234567@73) or paste from Patient IDs field',
          lookupFailed: 'Failed to look up patient',
          required: 'Patient number is required',
        },
        formatHint:
          'Format: <patient-id>@<org-id> (e.g., 1234567@73). You can also paste the full [id1@org,id2@org] format.',
        inputLabel: 'Patient number',
        inputPlaceholder: 'e.g., 1234567@73 or [1234567@73,7654321@88]',
        lookupButton: 'Look up',
        lookupButtonLoading: 'Searching...',
        patientDetails: {
          dateOfBirth: 'Date of birth',
          email: 'Email',
          phone: 'Phone',
          pulseIds: 'Patient IDs',
        },
        searching: 'Searching for patient...',
        selectPatient: 'Select this patient',
        toggleLabel: "Can't find the patient? Enter patient number manually",
      },
      matches: {
        actions: {
          activate: 'Activate',
        },
        badges: {
          dobMatch: 'DOB ✓',
          emailMismatch: 'Email ✗',
          nameMatch: 'Name ✓',
        },
        columns: {
          actions: 'Actions',
          birthDate: 'Birth Date',
          email: 'Email',
          equipeId: 'Equipe ID',
          gender: 'Gender',
          matchType: 'Match',
          name: 'Name',
          patientId: 'Patient ID',
          phoneNumber: 'Phone',
          status: 'Status',
        },
        found: 'Found {{count}} patient match(es)',
        loading: 'Searching for matches...',
        matchTypes: {
          both: 'Email + Phone',
          email: 'Email only',
          'name-dob': 'Name/DOB',
          phone: 'Phone only',
        },
        multipleWarning: '⚠️ Multiple matches found - verify before activating',
        noMatches: 'No patient matches found in Pulse system',
        status: {
          active: 'Active',
          inactive: 'Inactive',
        },
        title: 'Patient Matches',
      },
      modal: {
        activate: 'Activate selected patient',
        activating: 'Activating...',
        close: 'Close',
        description: 'Description and/or instructions here',
        emailMismatchConfirmation: {
          cancel: 'Cancel',
          confirm: 'Yes, link anyway',
          message:
            "The account's email address does not match the email on the selected patient record. Linking them gives this account access to that patient's medical information.",
          title: 'Email does not match',
          warning:
            'Only continue if you have verified this is the right patient.',
        },
        reject: 'Reject application',
        rejectConfirmation: {
          cancel: 'Cancel',
          confirm: 'Yes, reject application',
          message:
            'Are you sure you want to reject this application? The user will be notified by email and logged out of the app.',
          title: 'Confirm rejection',
          warning: 'This action cannot be undone.',
        },
        rejectReasonPlaceholder:
          'Enter the reason for rejection (e.g., "We cannot approve your application because your last appointment was too long ago. Please contact our information centre.")',
        rejectTitle: 'Reject this application',
        rejecting: 'Rejecting...',
        tableTitle: 'Potential patient matches',
        title: 'Patient matches',
      },
      noMatchesFound: 'No matches found',
      reviewReasons: {
        activation_failed: 'Activation failed',
        dob_conflict: 'DOB mismatch',
        email_conflict: 'Email mismatch',
        invalid_phone: 'Invalid phone',
        missing_pulse_ids: 'No patient IDs',
        multiple_matches: 'Multiple matches',
        no_match: 'No match',
        notEvaluated: 'New',
        unconfirmed_email: 'Email unconfirmed',
        unsafe_existing_external_id: 'Already linked',
      },
      title: 'Activations',
    },
    export: {
      bytesDownloaded: '{{bytes}} downloaded',
      cancel: 'Cancel',
      close: 'Close',
      status: {
        complete: 'Export complete!',
        downloading: 'Downloading export...',
        downloadingWithProgress:
          'Downloading... {{current}} of {{total}} records',
        error: 'Export failed',
        preparing: 'Preparing export...',
      },
      title: 'Exporting Users',
    },
    featureFlags: {
      actions: {
        add: 'New feature flag',
      },
      columns: {
        actions: 'Actions',
        description: 'Description',
        enabled: 'Enabled',
        key: 'Key',
        title: 'Title',
        value: 'Value',
      },
      createModal: {
        error:
          'There was problem creating new feature flag, check if key is unique',
        title: 'Create new feature flag',
      },
      deleteModal: {
        caption: 'Are you sure you want to delete feature flag {{title}}?',
        error: 'There was problem deleting feature flag',
        title: 'Delete feature flag',
      },
      editModal: {
        error: 'There was problem updating feature flag',
        title: 'Edit feature flag',
      },
      expandFeatureFlag: {
        actions: {
          clearSelection: 'Reset',
          deleteSelected: 'Delete',
          downloadCsv: 'Download values',
          selectAll: 'Select all',
          uploadCsv: 'Upload CSV',
        },
        addNewValuePlaceholder: 'Add new value or paste multiple rows',
        breadcrumb: 'Back to all features',
        error: {
          errorUpdatingFeatureFlag:
            'Error updating feature flag. Please try again.',
          noFeatureFlagFound:
            'Feature flag with key {{key}} not found. Please go back.',
          noItemsFound: 'No items found with {{query}}',
        },
        searchbarPlaceholder: 'Search...',
        uploadFileModal: {
          actions: {
            save: 'Save',
          },
          error: {
            fileNotCSV: 'Invalid file type. Please provide a CSV file',
            noFileProvided: 'No file provided',
          },
          title: 'Upload CSV file',
        },
        values: 'Values',
      },
      title: 'Feature flags',
    },
    permissions: {
      actions: {
        add: 'New permission',
      },
      columns: {
        actions: 'Actions',
        description: 'Description',
        name: 'Name',
      },
      createModal: {
        caption:
          'Permissions should also be added to the codebase to be used in the application',
        error:
          'There was problem creating new permission, check if name is unique',
        title: 'Create new permission',
      },
      deleteModal: {
        caption: 'Are you sure you want to delete permission {{name}}?',
        error:
          'There was problem deleting permission, make sure it is not in use',
        title: 'Delete permission',
      },
      editModal: {
        error: 'There was problem updating permission, check if name is unique',
        title: 'Edit permission',
      },
      title: 'Permissions',
    },
    queues: {
      actions: {
        add: 'New queue',
      },
      columns: {
        actions: 'Actions',
        description: 'Description',
        title: 'Title',
        userGroups: 'User groups',
      },
      createModal: {
        error:
          'There was problem creating new queue, check if name is unique and all the fields are present',
        title: 'Create new queue',
      },
      deleteModal: {
        caption: 'Are you sure you want to delete queue {{title}}?',
        error:
          'There was problem deleting the queue, check if it does not have user groups attached',
        title: 'Delete queue',
      },
      editModal: {
        error:
          'There was problem updating queue, check if name is unique and all the fields are present',
        title: 'Edit queue',
      },
      title: 'Queues',
    },
    reasons: {
      actions: {
        add: 'New reason',
        editOrder: 'Edit order',
        saveOrder: 'Save order',
      },
      columns: {
        actions: 'Actions',
        contentfulId: 'Contentful ID',
        organizations: 'Organizations',
        priority: 'Priority',
        queue: 'Queue',
        title: 'Title',
        urgent: 'Urgent',
      },
      createModal: {
        error:
          'There was problem creating new reason, check if title is unique and all the fields are present',
        title: 'Create new reason',
      },
      deleteModal: {
        caption: 'Are you sure you want to delete reason {{title}}?',
        error:
          'There was problem deleting reason, make sure it is not in use in conversations',
        title: 'Delete reason',
      },
      editModal: {
        error:
          'There was problem updating reason, check if title is unique and all the fields are present',
        title: 'Edit reason',
      },
      title: 'Reasons',
    },
    roles: {
      actions: {
        add: 'New role',
      },
      columns: {
        actions: 'Actions',
        azureGroups: 'Azure Groups',
        description: 'Description',
        name: 'Name',
        permissions: 'Permissions',
        value: 'Value',
      },
      createModal: {
        error:
          'There was problem creating new role, check if name is unique and permissions are present',
        title: 'Create new role',
      },
      deleteModal: {
        caption: 'Are you sure you want to delete role {{name}}?',
        error: 'There was problem deleting role, make sure it is not in use',
        title: 'Delete role',
      },
      editModal: {
        error: 'There was problem updating role, check if name is unique',
        title: 'Edit role',
      },
      title: 'Roles',
    },
    tabs: {
      activations: 'Activations',
      featureFlags: 'Feature flags',
      reasons: 'Reasons and Queues',
      roles: 'Roles and Permissions',
      users: 'Users',
    },
    users: {
      actions: {
        add: 'New user',
        download: 'Download users',
        downloading: 'Downloading...',
      },
      columns: {
        actions: 'Actions',
        email: 'Email',
        lastSignIn: 'Last sign in',
        name: 'Name',
        patientId: 'Patient ID',
        roles: 'Roles',
        verified: 'Verified',
      },
      createModal: {
        error:
          'There was problem creating new user, check if email is unique and name is present',
        title: 'Create new user',
      },
      deleteModal: {
        caption: 'Are you sure you want to delete user {{email}}?',
        error: 'There was problem deleting user',
        title: 'Delete user',
      },
      display: 'Display: {{amount}} of {{total}}',
      editModal: {
        emailMismatchConfirmation: {
          cancel: 'Cancel',
          confirm: 'Yes, save anyway',
          message:
            'This patient ID belongs to a patient record with a different email address. Saving links this account to that patient.',
          title: 'Email does not match',
        },
        error: 'There was problem updating user, check if email is unique',
        title: 'Edit user',
      },
      filters: {
        email: 'Email',
        emailPlaceholder: 'Filter by email...',
        name: 'Name',
        namePlaceholder: 'Filter by name...',
        pulseIds: 'Pulse IDs',
        pulseIdsPlaceholder: 'Filter by pulse IDs...',
        search: 'Global Search',
        searchPlaceholder: 'Search users...',
        status: 'Status',
        statusActive: 'Active',
        statusAll: 'All Statuses',
        statusArchived: 'Archived',
        statusPlaceholder: 'Select status...',
        type: 'User Type',
        typeAll: 'All Types',
        typeClinician: 'Clinician',
        typePatient: 'Patient',
        typePlaceholder: 'Select user type...',
      },
      pagination: {
        loadMore: 'Load More',
        loading: 'Loading...',
        showing: 'Showing {{current}} of {{total}} users',
        showingUnverified: 'Showing {{current}} unverified users',
        showingVerified: 'Showing {{current}} verified users',
      },
      title: 'Users',
      unknown: 'unknown',
    },
  },
  widgets: {
    externalCareProviders: {
      ['orthopedic-physiotherapist']: {
        description:
          'Xpert Clinics works with physiotherapists who know how to help you in the best possible way',
        listView: 'List',
        mapView: 'Map',
        noResults: 'No physiotherapists found',
        noResultsCaption:
          'Fill in the complete postal code (eg.&nbsp;1234&nbsp;BA) to find a location nearby',
        searchPlaceholder: 'Search physiotherapists or postal code',
        title: 'Explore our preferred physiotherapists',
      },
    },
  },
}
